import PropTypes from 'prop-types';

import childrenOfTypes from '../../utils/childrenOfTypes';
import ActionMenuItem from './ActionMenuItem';
import ActionMenuDiver from './ActionMenuDivider';
import DataGridActionMenu from '../../molecules/DataGrid/DataGridActionMenu/DataGridActionMenu';

export const ActionMenu = DataGridActionMenu;

ActionMenu.MenuItem = ActionMenuItem;
ActionMenu.Divider = ActionMenuDiver;

ActionMenu.propTypes = {
  children: childrenOfTypes(ActionMenuItem, ActionMenuDiver).isRequired,
  /** Passed to data-id prop on button component
   *  @ignore
   */
  id: PropTypes.string,
};

ActionMenu.defaultProps = {
  id: null,
};

export default ActionMenu;
